    <template >
  <div v-role="roles">

  <div>
  <div class="formPosition">



  
  <v-card style="margin:auto;" width="1200" >
        <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <v-form
    ref="form2"
    v-model="formValid2"
    lazy-validation
  >


  <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialogX" persistent max-width="490">
              <v-card>
                <v-overlay :value="overlay">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Ao concordar com está operação , a disciplina selecionada não poderá ser vista no anolectivo actual !
                  Caso tenha certeza, clique em concordar com a operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogX=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="SaveMudarX()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->


         <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialogB" persistent max-width="490">
              <v-card>
                <v-overlay :value="overlay">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>
                  <v-row>
                     <v-col cols="12" md="12">
                         <v-select
                         v-model="bienalSelected"
                         outlined
                         :items="bienais"
                         item-text="descricao"
                         return-object
                         label="Selecione a bienal"
                      ></v-select>
                     </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogB=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" :disabled="bienalSelected === null || bienalSelected === ''" text @click="SaveMudarBienal()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->




          <v-card-title style="background-color:#006699; color:white" dark>Habilitar/ Desabilitar disciplinas</v-card-title>
          <v-alert
                      v-model="alert"
                      dismissible
                      :type="colorAlert"
                      border="left"
                      transition="scale-transition"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>

               <v-row no-gutters>
          <v-col>
            <v-card class="d-flex flex-row mb-6" tile>
              <v-list flat>
               <v-header>
                 <v-row>
                   <v-col md="1"></v-col>
                    <v-col cols="12" md="6">
                       <v-select
                         v-model="cursoSelected"
                         outlined
                         :items="cursos"
                         item-text="descricao"
                         return-object
                         label="Selecione o curso"
                         @change="SelecionaCurso()"
                      ></v-select>
                    </v-col>
                     <v-col cols="12" md="4">
                       <v-select
                       v-model="classeSelected"
                          outlined
                         :disabled="cursoSelected === null"
                         :items="classes"
                         item-text="descricao"
                         item-value="id"
                         label="Selecione a classe "
                         @change="FiltrarDisciplinas()"
                      ></v-select>
                    </v-col>
                 </v-row>
               </v-header>

                <hr width="1200" />

               
                <v-list-item-group v-model="item" color="primary">

                  <v-row  style="margin-left:50px">
                    <v-col cols="12" sm="12" md="3">N.</v-col>
                    <v-col cols="12" sm="12" md="3">Disciplinas</v-col>
                    <v-col cols="12" sm="12" md="2">Ano académico</v-col>
                    <v-col cols="12" sm="12" md="2">Bienal</v-col>
                    <v-col cols="12" sm="12" md="2">Ação</v-col>
                  </v-row>

                  <v-list-item v-for="(item, i) in disciplinasFiltered" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>

                 <v-row  >
                      <v-col cols="12" sm="12" md="3">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="3">
                        <v-list-item-title v-text="item.descricao"></v-list-item-title>
                      </v-col>

                      <v-col cols="12" sm="12" md="2">
                        <v-list-item-title  v-if="item.anoacademico < 8" v-text="item.anoacademico"></v-list-item-title>
                        <span style="color:red" v-if="item.anoacademico === 8">Excluido</span>
                      </v-col>

                      <v-col cols="12" sm="12" md="2">
                        <v-list-item-title v-text="item.bienal"></v-list-item-title>
                      </v-col>


                      <v-col cols="12" sm="12" md="2">
                        <v-btn color="green" v-if="item.bienal !== 'x'"  fab  x-small dark>
                          <v-icon   @click="UpdateBienal(item)">done</v-icon>
                        </v-btn>
                         <v-btn color="red" v-if="item.bienal === 'x'"  fab  x-small dark>
                          <v-icon   @click="UpdateBienal(item)">remove_done</v-icon>
                        </v-btn>
                      </v-col>

                    </v-row>

                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
     </v-form>
      </v-card>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    overlay: false,
    msgAlert: '',
    colorAlert: 'success',
    alert: false,
    dial_: false,
    index: -1,
    dialog: false,
    dialog2: false,
    isLoading: false,
    dialogB: false,
    formValid: true,
    formValid2: true,
    cursoSelected: null,
    classeSelected: '',
    disciplinasFiltered: [],
    anocademico:8,
    on: false,
    dialogX: false,
    roles: 'adm',
    text: '',
    itemDelete: null,
    editedpk: 0,
    role_usuario: '',
    disciplinas: [],
    item_disciplina: null,
    bienalSelected: null,
    bienais: [
      0,
      1,
      2,
      3,
      "Excluir"
    ],
    classes: [
       {id:1,descricao:"10ª Classe"},
       {id:2,descricao:"11ª Classe"},
       {id:3,descricao:"12ª Classe"},
       {id:4,descricao:"13ª Classe"},
       {id:5,descricao:"Sem filtro"},
    ],
    _classe: '',
    offset: true,
    iddisciplina: 0,
    closeOnClick: true,
    item: 1,
    cursos: [],
    anolectivos: [],
    control_modelo_certificados: [],
    editedIndex: -1,
    is_modelo_certificado: false,
    editedItem: {
      curso: { descricao: '', idCurso: 0 },
      anolectivo: { novadescricao: '', idAnoLectivo: 0 },
      idcontrol_disciplina_certificado: 0
    },
    defaultItem: {
      curso: { descricao: '', idCurso: 0 },
      anolectivo: { novadescricao: '', idAnoLectivo: 0 },
      idcontrol_disciplina_certificado: 0
    }
  }),
  computed: {
  },

  watch: {
  },
  created () {
    this.initializeCurso()
    this.initializeAnoLectivo()
  },

  methods: {
    deleteItem (item) {
      this.index = this.disciplinas.indexOf(item)
      this.dialog = true
    },
    eliminar () {
      this.disciplinas.splice(this.index, 1)
      this.dialog = false
    },

    async save () {
      this.dial_ = false
      try {
        this.overlay = true
        let msg2 = await axios
          .post('/modelodisciplinaInsert', { dados: this.disciplinas, curso: this.editedItem.curso, anolectivo: this.editedItem.anolectivo, status_: true, autor_: ls.get('nomeUsuario') })
          .then(res => res.data)
        if (msg2.affectedRows > 0) {
          this.disciplinas = []
          this.editedItem = this.defaultItem
          this.alert = true
          this.colorAlert = 'success'
          this.msgAlert = 'Modelo criado com sucesso!'
          setTimeout(() => {
            this.alert = false
            this.dial_ = true
          }, 2000)
        }

        this.overlay = false
        this.dialog2 = false
      } catch (error) {
        this.overlay = false
        this.dialog2 = false
        this.alert = true
        this.colorAlert = 'error'
        this.msgAlert = error
        setTimeout(() => {
          this.alert = false
        }, 2000)
      }
    },

    async initializeDisciplinas () {
      if (this.$refs.form.validate()) {
        try {
          let msg = await axios
            .post('/load_modelo', { idCurso: this.editedItem.curso.idCurso, idAnoLectivo: this.editedItem.anolectivo.idAnoLectivo })
            .then(res => res.data)
          if (msg.length === 0) {
            this.disciplinas = await axios
              .post('/modelo_disciplina_curso', { idCurso: this.editedItem.curso.idCurso })
              .then(res => res.data)
            this.dial_ = false
          } else {
            this.is_modelo_certificado = true
          }
        } catch (error) {
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },
    async initializeCurso () {
      try {
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeAnoLectivo () {
      try {
        this.anolectivos = await axios
          .get('/anolectivoAll')
          .then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
  async  SelecionaCurso (){
       this.classeSelected = ''
       this.overlay = true
        try {
        this.disciplinas = await axios
          .post('/disciplina_curso', {idCurso:this.cursoSelected.idCurso})
          .then(res => res.data)
        this.disciplinasFiltered = this.disciplinas
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }finally{
        this.overlay = false
      }
    },
    FiltrarDisciplinas (){
      if(this.classeSelected !== 5)
          this.disciplinasFiltered = this.disciplinas.filter(d=>d.idCurso === this.cursoSelected.idCurso && d.anoacademico === this.classeSelected)
      else
        this.disciplinasFiltered = this.disciplinas.filter(d=>d.idCurso === this.cursoSelected.idCurso)

    },

    UpdateBienalX (obj) {
      this.item_disciplina = obj
     this.dialogX = true
    },
    UpdateBienal (obj){
      this.item_disciplina = obj
      this.dialogB = true
    },
   async SaveMudarX (){
      // this.overlay = true
        try {
        let result = await axios
          .post('/disciplinaUpdateBienal', {bienal:'x', anoacademico: this.anocademico , disciplina:this.item_disciplina})
          .then(res => res.data)
        this.SelecionaCurso()
        this.dialogX = false
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }finally{
        this.overlay = false
      }
    },
  async  SaveMudarBienal (){

    if( this.bienalSelected !== "Excluir"){
        try {
            let result = await axios
              .post('/disciplinaUpdateBienal', {bienal:this.bienalSelected, disciplina:this.item_disciplina})
              .then(res => res.data)
            this.SelecionaCurso()
            this.dialogB = false
            this.dialogX = false
          } catch (error) {
            this.$store.dispatch('textMessage', {
              msg: error,
              classMessage: 'msgError',
              timeout: 3000
            })
          }finally{
            this.overlay = false
          }
        
    }else{
        this.dialogX = true
    }
      
    }
  }
}
</script>
